<template>
    <div>
        <ValidationObserver ref="formModalValidate">
            <b-row>
                <b-col cols="12" md="6">
                    <b-form-group :label="$t('document_type')">
                        <div class="label-as-input">{{ isNotNullValue(form.document_type_name) || isNotNullValue(form.document_type) }}</div>
                    </b-form-group>
                </b-col>

                <template v-if="form.document_type">
                    <b-col cols="6">
                        <ValidationProvider name="date_of_document" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('date_of_document')">
                                <b-form-input
                                    v-model="form.date_of_document"
                                    type="date"
                                    :class="errors[0] ? 'is-invalid' : ''"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="6">
                        <ValidationProvider name="index_by_bau" rules="" v-slot="{ errors }">
                            <b-form-group :label="$t('index_by_bau')">
                                <b-form-input
                                    v-model="form.index_by_bau"
                                    :class="errors[0] ? 'is-invalid' : ''"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="6">
                        <ValidationProvider name="index_of_document" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('index_of_document')">
                                <b-form-input
                                    v-model="form.index_of_document"
                                    :class="errors[0] ? 'is-invalid' : ''"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" v-if="['outgoing_document', 'incoming_document'].includes(form.document_type)">
                        <ValidationProvider name="name_of_sender" :rules="['outgoing_document', 'incoming_document'].includes(form.document_type) ? 'required' : ''"  v-slot="{ errors }">
                            <b-form-group :label="$t('name_of_sender')">
                                <b-form-input
                                    v-model="form.name_of_sender"
                                    :class="errors[0] ? 'is-invalid' : ''"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" v-if="['outgoing_document', 'incoming_document'].includes(form.document_type)">
                        <ValidationProvider name="name_of_recipient" :rules="['outgoing_document', 'incoming_document'].includes(form.document_type) ? 'required' : ''" v-slot="{ errors }">
                            <b-form-group :label="$t('name_of_recipient')">
                                <b-form-input
                                    v-model="form.name_of_recipient"
                                    :class="errors[0] ? 'is-invalid' : ''"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" v-if="['outgoing_document', 'incoming_document'].includes(form.document_type)">
                        <ValidationProvider name="executor" :rules="['outgoing_document', 'incoming_document'].includes(form.document_type) ? 'required' : ''" v-slot="{ errors }">
                            <b-form-group :label="$t('executor')">
                                <b-form-input
                                    v-model="form.executor"
                                    :class="errors[0] ? 'is-invalid' : ''"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" v-if="['outgoing_document', 'incoming_document'].includes(form.document_type)">
                        <ValidationProvider name="delivery_type" :rules="['outgoing_document', 'incoming_document'].includes(form.document_type) ? 'required' : ''" v-slot="{valid, errors}">
                            <b-form-group :label="$t('delivery_type')">
                                <parameter-selectbox :validate-error="errors[0]" v-model="form.delivery_type"
                                                     code="administrative_document_delivery_type"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6">
                        <ValidationProvider name="number_of_pages" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('number_of_pages')">
                                <b-form-input
                                    v-model="form.number_of_pages"
                                    type="number"
                                    :class="errors[0] ? 'is-invalid' : ''"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" v-if="['rectors_order', 'business_partner_meeting', 'academic_council_order', 'faculty_council_order', 'minutes', 'agreements'].includes(form.document_type)">
                        <ValidationProvider name="grade" :rules="['rectors_order', 'business_partner_meeting', 'academic_council_order', 'faculty_council_order', 'minutes', 'agreements'].includes(form.document_type) ? 'required' : ''" v-slot="{ errors }">
                            <b-form-group :label="$t('grade')">
                                <b-form-input
                                    v-model="form.grade"
                                    :class="errors[0] ? 'is-invalid' : ''"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12">
                        <ValidationProvider name="explanation" rules="required" v-slot="{ errors }">
                            <b-form-group :label="$t('explanation')">
                                <b-form-textarea
                                    v-model="form.explanation"
                                    rows="3"
                                    :class="errors[0] ? 'is-invalid' : ''"
                                />
                                <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <template v-if="['agreements'].includes(form.document_type)">
                        <b-col cols="6" md="6">
                            <ValidationProvider name="start_date" :rules="['agreements'].includes(form.document_type) ? 'required' : ''"  v-slot="{ valid, errors }">
                                <b-form-group :label="$t('start_date')">
                                    <select-date v-model="form.start_date" :state="errors[0] ? false : null" />
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="6" md="6">
                            <ValidationProvider name="end_date" rules="" v-slot="{ valid, errors }">
                                <b-form-group :label="$t('end_date')">
                                    <select-date v-model="form.end_date" :state="errors[0] ? false : null" />
                                    <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col cols="12" md="6">
                            <b-form-group :label="$t('type_of_agreement')">
                                <parameter-selectbox v-model="form.type_of_agreement"
                                                     code="administrative_document_type_of_agreements"/>
                            </b-form-group>
                        </b-col>
                    </template>
                </template>
            </b-row>
        </ValidationObserver>

        <div class="col-6 mt-3 d-flex" v-if="form.document_type">
            <b-button
                @click="updateForm"
                type="button"
                :disabled="formLoading"
                variant="primary"
                class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </div>
    </div>
</template>

<script>
import {ValidationProvider, ValidationObserver} from "vee-validate"
import AdministrativeDocumentManagementService from "@/services/AdministrativeDocumentManagementService";

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    props: {
        formId: {
            type: Number,
        }
    },
    data() {
        return {
            formLoading: false,
            form: {},
        }
    },
    watch: {
        formId: function (val) {
            if(val) this.get(val)
        }
    },
    async created() {
        if(this.formId) await this.get(this.formId)
    },
    methods: {
        get(id) {
            this.formLoading = true;
            AdministrativeDocumentManagementService.get(id)
                .then((response) => {
                    this.form = response.data.data;
                    this.formLoading = false;
                })
                .catch((error) => {
                    this.formLoading = false;
                    if (error.response && error.response.data.message) {
                        this.$toast.error(this.$t("api." + error.response.data.message));
                    }
                });
        },
        async updateForm() {
            const isValid = await this.$refs.formModalValidate.validate();
            if (isValid && this.formId) {
                this.formLoading = true;

                const payload = {};
                Object.keys(this.form).forEach((key) => {
                    const value = this.form[key];

                    if (value !== null && value !== undefined && value !== '') {
                        payload[key] = value;
                    }
                });

                AdministrativeDocumentManagementService.update(this.formId, payload)
                    .then((response) => {
                        this.formLoading = false;
                        this.$toast.success(this.$t("api." + response.data.message));
                        this.$emit("updateFormSuccess")
                    })
                    .catch((error) => {
                        this.formLoading = false;
                        this.showErrors(error, this.$refs.formModalValidate)
                    })
            }
        }
    }
}
</script>
